var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    { attrs: { justify: "space-around" } },
    [
      _c("loading", { attrs: { loading: _vm.loading } }),
      _vm._v(" "),
      _vm.loadComplete
        ? _c(
            "v-col",
            { attrs: { cols: "2" } },
            [
              _c(
                "v-card",
                { staticClass: "elevation-0" },
                [
                  _vm.loadComplete
                    ? _c(
                        "v-tabs",
                        {
                          staticClass: "mt-3",
                          attrs: {
                            "show-arrows": "",
                            color: "basil",
                            grow: "",
                            vertical: ""
                          },
                          model: {
                            value: _vm.tab,
                            callback: function($$v) {
                              _vm.tab = $$v
                            },
                            expression: "tab"
                          }
                        },
                        [
                          _c(
                            "v-tab",
                            {
                              staticClass: "tab-border",
                              attrs: { "active-class": "tab-active" }
                            },
                            [
                              _c("span", { staticClass: "font-weight-bold" }, [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$t(
                                        "view.sales_force.reflect.label.tabs.torihikisaki"
                                      )
                                    ) +
                                    "\n                    "
                                )
                              ]),
                              _vm._v(" "),
                              _vm.loadComplete
                                ? [
                                    _c(
                                      "v-icon",
                                      { attrs: { color: "green" } },
                                      [_vm._v("mdi-check-circle")]
                                    )
                                  ]
                                : _vm._e()
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tab",
                            {
                              staticClass: "tab-border",
                              attrs: { "active-class": "tab-active" }
                            },
                            [
                              _c("span", { staticClass: "font-weight-bold" }, [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$t(
                                        "view.sales_force.reflect.label.tabs.torihikisaki_sekininsya_apply"
                                      )
                                    ) +
                                    "\n                    "
                                )
                              ]),
                              _vm._v(" "),
                              _vm.loadComplete
                                ? [
                                    _c(
                                      "v-icon",
                                      { attrs: { color: "green" } },
                                      [_vm._v("mdi-check-circle")]
                                    )
                                  ]
                                : _vm._e()
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tab",
                            {
                              staticClass: "tab-border",
                              staticStyle: { "text-transform": "none" },
                              attrs: { "active-class": "tab-active" }
                            },
                            [
                              _c("span", { staticClass: "font-weight-bold" }, [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$t(
                                        "view.sales_force.reflect.label.tabs.opportunity_entry"
                                      )
                                    ) +
                                    "\n                    "
                                )
                              ]),
                              _vm._v(" "),
                              _vm.isLinkComplete("opportunityEntryStatusPre")
                                ? [
                                    _c(
                                      "v-icon",
                                      { attrs: { color: "green" } },
                                      [_vm._v("mdi-check-circle")]
                                    )
                                  ]
                                : _vm._e()
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tab",
                            {
                              staticClass: "tab-border",
                              staticStyle: { "text-transform": "none" },
                              attrs: { "active-class": "tab-active" }
                            },
                            [
                              _c("span", { staticClass: "font-weight-bold" }, [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$t(
                                        "view.sales_force.reflect.label.tabs.opportunity_basic"
                                      )
                                    ) +
                                    "\n                    "
                                )
                              ]),
                              _vm._v(" "),
                              _vm.isLinkComplete("opportunityBasicStatusPre")
                                ? [
                                    _c(
                                      "v-icon",
                                      { attrs: { color: "green" } },
                                      [_vm._v("mdi-check-circle")]
                                    )
                                  ]
                                : _vm._e()
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tab",
                            {
                              staticClass: "tab-border",
                              staticStyle: { "text-transform": "none" },
                              attrs: { "active-class": "tab-active" }
                            },
                            [
                              _c("span", { staticClass: "font-weight-bold" }, [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$t(
                                        "view.sales_force.reflect.label.tabs.opportunity_medium"
                                      )
                                    ) +
                                    "\n                    "
                                )
                              ]),
                              _vm._v(" "),
                              _vm.isLinkComplete("opportunityMediumStatusPre")
                                ? [
                                    _c(
                                      "v-icon",
                                      { attrs: { color: "green" } },
                                      [_vm._v("mdi-check-circle")]
                                    )
                                  ]
                                : _vm._e()
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tab",
                            {
                              staticClass: "tab-border",
                              staticStyle: { "text-transform": "none" },
                              attrs: { "active-class": "tab-active" }
                            },
                            [
                              _c("span", { staticClass: "font-weight-bold" }, [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$t(
                                        "view.sales_force.reflect.label.tabs.opportunity_standard"
                                      )
                                    ) +
                                    "\n                    "
                                )
                              ]),
                              _vm._v(" "),
                              _vm.isLinkComplete("opportunityStandardStatusPre")
                                ? [
                                    _c(
                                      "v-icon",
                                      { attrs: { color: "green" } },
                                      [_vm._v("mdi-check-circle")]
                                    )
                                  ]
                                : _vm._e()
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tab",
                            {
                              staticClass: "tab-border",
                              staticStyle: { "text-transform": "none" },
                              attrs: { "active-class": "tab-active" }
                            },
                            [
                              _c("span", { staticClass: "font-weight-bold" }, [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$t(
                                        "view.sales_force.reflect.label.tabs.opportunity_professional"
                                      )
                                    ) +
                                    "\n                    "
                                )
                              ]),
                              _vm._v(" "),
                              _vm.isLinkComplete(
                                "opportunityProfessionalStatusPre"
                              )
                                ? [
                                    _c(
                                      "v-icon",
                                      { attrs: { color: "green" } },
                                      [_vm._v("mdi-check-circle")]
                                    )
                                  ]
                                : _vm._e()
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _vm.showUpgradeTab
                            ? _c(
                                "v-tab",
                                {
                                  staticClass: "tab-border",
                                  staticStyle: { "text-transform": "none" },
                                  attrs: {
                                    "active-class": "tab-active",
                                    disabled: _vm.disabledUpgradeTab
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(
                                            _vm.$t(
                                              "view.sales_force.reflect.label.tabs.opportunity_upgrade"
                                            )
                                          ) +
                                          "\n                    "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.isLinkComplete(
                                    "opportunityToUpgradeStatusPre"
                                  )
                                    ? [
                                        _c(
                                          "v-icon",
                                          { attrs: { color: "green" } },
                                          [_vm._v("mdi-check-circle")]
                                        )
                                      ]
                                    : _vm._e()
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-tab",
                            {
                              staticClass: "tab-border",
                              staticStyle: { "text-transform": "none" },
                              attrs: { "active-class": "tab-active" }
                            },
                            [
                              _c("span", { staticClass: "font-weight-bold" }, [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$t(
                                        "view.sales_force.reflect.label.tabs.opportunity_additional_tablet"
                                      )
                                    ) +
                                    "\n                    "
                                )
                              ]),
                              _vm._v(" "),
                              _vm.isLinkComplete(
                                "opportunityAdditionalTabletStatusPre"
                              )
                                ? [
                                    _c(
                                      "v-icon",
                                      { attrs: { color: "green" } },
                                      [_vm._v("mdi-check-circle")]
                                    )
                                  ]
                                : _vm._e()
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tab",
                            {
                              staticClass: "tab-border",
                              staticStyle: { "text-transform": "none" },
                              attrs: { "active-class": "tab-active" }
                            },
                            [
                              _c("span", { staticClass: "font-weight-bold" }, [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$t(
                                        "view.sales_force.reflect.label.tabs.opportunity_motion_ai"
                                      )
                                    ) +
                                    "\n                    "
                                )
                              ]),
                              _vm._v(" "),
                              _vm.isLinkComplete("opportunityMotionAiStatusPre")
                                ? [
                                    _c(
                                      "v-icon",
                                      { attrs: { color: "green" } },
                                      [_vm._v("mdi-check-circle")]
                                    )
                                  ]
                                : _vm._e()
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _vm.showReloadButton()
                            ? _c(
                                "v-tab",
                                {
                                  staticClass: "tab-border",
                                  attrs: { "active-class": "tab-active" }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(
                                            _vm.$t(
                                              "view.sales_force.reflect.label.tabs.application_details"
                                            )
                                          ) +
                                          "\n                    "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  !_vm.isLinkComplete(
                                    "applicationDetailStatusPre"
                                  )
                                    ? [
                                        _c(
                                          "v-icon",
                                          { attrs: { color: "orange" } },
                                          [_vm._v("mdi-alert")]
                                        )
                                      ]
                                    : [
                                        _c(
                                          "v-icon",
                                          { attrs: { color: "green" } },
                                          [_vm._v("mdi-check-circle")]
                                        )
                                      ]
                                ],
                                2
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-col",
        { attrs: { cols: "10" } },
        [
          _c(
            "v-card",
            { staticClass: "elevation-0" },
            [
              _c(
                "v-row",
                { staticClass: "mt-3" },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
                      attrs: { cols: "12", sm: "12", md: "4" }
                    },
                    [
                      _c(
                        "v-sheet",
                        {
                          staticClass:
                            "pt-3 pb-3 align-center fixed-label-area",
                          attrs: { color: "grey lighten-3" }
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass:
                                "mb-0 font-weight-bold ml-4 fixed-label"
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$t(
                                      "view.sales_force.reflect.label.top.current_user"
                                    )
                                  ) +
                                  "\n                        "
                              )
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    {
                      staticClass: "mb-0 mt-0 pt-2 pb-0",
                      attrs: { cols: "12", sm: "8", md: "4" }
                    },
                    [
                      _c("label", { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s(_vm.signInEmail))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    {
                      staticClass: "mb-0 mt-0 pl-5 pt-2 pb-0",
                      attrs: { cols: "12", sm: "4", md: "4" }
                    },
                    [
                      _c("move-sales-force-button", {
                        attrs: {
                          "sales-force-id": _vm.salesForceUserId,
                          "sales-force-type": "User"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-row",
                { staticClass: "mt-3" },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
                      attrs: { cols: "12", sm: "12", md: "4" }
                    },
                    [
                      _c(
                        "v-sheet",
                        {
                          staticClass:
                            "pt-3 pb-3 align-center fixed-label-area",
                          attrs: { color: "grey lighten-3" }
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass:
                                "mb-0 font-weight-bold ml-4 fixed-label"
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$t(
                                      "view.sales_force.reflect.label.torihikisaki_sekininsya.pre_id"
                                    )
                                  ) +
                                  "\n                        "
                              )
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    {
                      staticClass: "mb-0 mt-0 pt-2 pb-0",
                      attrs: { cols: "12", sm: "8", md: "4" }
                    },
                    [
                      _c("v-text-field", {
                        staticClass: "mt-0 pt-0 pb-0",
                        attrs: {
                          "persistent-hint": "",
                          disabled: _vm.showReloadButton(),
                          hint: _vm.$t(
                            "view.sales_force.reflect.hint.torihikisaki_sekininsya.pre_id"
                          ),
                          placeholder: _vm.$t(
                            "view.sales_force.reflect.placeholder.torihikisaki_sekininsya.id"
                          ),
                          autocomplete: "off"
                        },
                        model: {
                          value: _vm.salesForceInfo.applyTorihikisakiId,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.salesForceInfo,
                              "applyTorihikisakiId",
                              $$v
                            )
                          },
                          expression: "salesForceInfo.applyTorihikisakiId"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    {
                      staticClass: "mb-0 mt-0 pl-5 pt-2 pb-0",
                      attrs: { cols: "12", sm: "4", md: "4" }
                    },
                    [
                      _c("move-sales-force-button", {
                        attrs: {
                          "sales-force-id":
                            _vm.salesForceInfo.applyTorihikisakiId,
                          "sales-force-type": "Contact"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-row",
                { staticClass: "mt-3" },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
                      attrs: { cols: "12", sm: "12", md: "4" }
                    },
                    [
                      _c(
                        "v-sheet",
                        {
                          staticClass:
                            "pt-3 pb-3 align-center fixed-label-area",
                          attrs: { color: "grey lighten-3" }
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass:
                                "mb-0 font-weight-bold ml-4 fixed-label"
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$t(
                                      "view.sales_force.reflect.label.opportunity.opportunity_id"
                                    )
                                  ) +
                                  "\n                        "
                              )
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    {
                      staticClass: "mb-0 mt-0 pt-2 pb-0",
                      attrs: { cols: "12", sm: "8", md: "4" }
                    },
                    [
                      _c("v-text-field", {
                        staticClass: "mt-0 pt-0 pb-0",
                        attrs: {
                          "persistent-hint": "",
                          disabled: _vm.showReloadButton(),
                          hint: _vm.$t(
                            "view.sales_force.reflect.hint.opportunity.pre_id"
                          ),
                          placeholder: _vm.$t(
                            "view.sales_force.reflect.placeholder.opportunity.opportunity_id"
                          ),
                          autocomplete: "off"
                        },
                        model: {
                          value: _vm.salesForceInfo.opportunityId,
                          callback: function($$v) {
                            _vm.$set(_vm.salesForceInfo, "opportunityId", $$v)
                          },
                          expression: "salesForceInfo.opportunityId"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    {
                      staticClass: "mb-0 mt-0 pl-5 pt-2 pb-0",
                      attrs: { cols: "12", sm: "4", md: "4" }
                    },
                    [
                      _c("move-sales-force-button", {
                        attrs: {
                          "sales-force-id": _vm.salesForceInfo.opportunityId,
                          "sales-force-type": "Opportunity"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-row",
                [
                  _c("v-col", {
                    staticClass: "ml-3 mb-0 mt-0 pt-3 pb-0",
                    attrs: { cols: "12", sm: "12", md: "4" }
                  }),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    {
                      staticClass: "mb-0 mt-0 pt-3 pb-0",
                      attrs: { cols: "12", sm: "12", md: "4" }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            depressed: "",
                            block: true,
                            type: "submit",
                            color: "#11479B",
                            dark: true
                          },
                          on: { click: _vm.loadSalesForceInfo }
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$t(
                                  "view.sales_force.reflect.button_caption.load_sales_force"
                                )
                              ) +
                              "\n                    "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.showReloadButton()
                    ? _c(
                        "v-col",
                        {
                          staticClass: "mb-0 mt-0 pt-3 pb-0",
                          attrs: { cols: "12", sm: "12", md: "3" }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { depressed: "" },
                              on: {
                                click: function($event) {
                                  return _vm.createNewPlan()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$t(
                                      "view.sales_force.reflect.button_caption.create_new_plan"
                                    )
                                  ) +
                                  "\n                    "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider", { staticClass: "mt-3" }),
              _vm._v(" "),
              _vm.loadComplete
                ? _c(
                    "v-tabs-items",
                    {
                      staticClass: "pa-3",
                      model: {
                        value: _vm.tab,
                        callback: function($$v) {
                          _vm.tab = $$v
                        },
                        expression: "tab"
                      }
                    },
                    [
                      _c(
                        "v-tab-item",
                        [
                          _c("torihikisaki", {
                            attrs: {
                              "init-data": _vm.documentData,
                              "fetch-sales-force-info": _vm.fetchSalesForceInfo,
                              "init-sales-force-data": _vm.salesForceInfo,
                              "readonly-mode": true
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab-item",
                        [
                          _c("torihikisaki-sekininsya-apply", {
                            attrs: {
                              "init-data": _vm.documentData,
                              "fetch-sales-force-info": _vm.fetchSalesForceInfo,
                              "init-sales-force-data": _vm.salesForceInfo,
                              "readonly-mode": true
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab-item",
                        [
                          _c("opportunity-entry-pre", {
                            attrs: {
                              "init-data": _vm.documentData,
                              "is-link-complete": _vm.isLinkComplete(
                                "opportunityEntryStatusPre"
                              ),
                              "fetch-sales-force-info": _vm.fetchSalesForceInfo,
                              "price-book-data": _vm.priceBook2DataEntry,
                              "init-sales-force-data": _vm.salesForceInfo
                            },
                            on: { reflect: _vm.reflect }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab-item",
                        [
                          _c("opportunity-basic-pre", {
                            attrs: {
                              "init-data": _vm.documentData,
                              "is-link-complete": _vm.isLinkComplete(
                                "opportunityBasicStatusPre"
                              ),
                              "fetch-sales-force-info": _vm.fetchSalesForceInfo,
                              "price-book-data": _vm.priceBook2DataBasic,
                              "init-sales-force-data": _vm.salesForceInfo
                            },
                            on: { reflect: _vm.reflect }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab-item",
                        [
                          _c("opportunity-medium-pre", {
                            attrs: {
                              "init-data": _vm.documentData,
                              "is-link-complete": _vm.isLinkComplete(
                                "opportunityMediumStatusPre"
                              ),
                              "fetch-sales-force-info": _vm.fetchSalesForceInfo,
                              "price-book-data": _vm.priceBook2DataMedium,
                              "init-sales-force-data": _vm.salesForceInfo
                            },
                            on: { reflect: _vm.reflect }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab-item",
                        [
                          _c("opportunity-standard-pre", {
                            attrs: {
                              "init-data": _vm.documentData,
                              "is-link-complete": _vm.isLinkComplete(
                                "opportunityStandardStatusPre"
                              ),
                              "fetch-sales-force-info": _vm.fetchSalesForceInfo,
                              "price-book-data": _vm.priceBook2DataStandard,
                              "init-sales-force-data": _vm.salesForceInfo
                            },
                            on: { reflect: _vm.reflect }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab-item",
                        [
                          _c("opportunity-professional-pre", {
                            attrs: {
                              "init-data": _vm.documentData,
                              "is-link-complete": _vm.isLinkComplete(
                                "opportunityProfessionalStatusPre"
                              ),
                              "fetch-sales-force-info": _vm.fetchSalesForceInfo,
                              "price-book-data": _vm.priceBook2DataProfessional,
                              "init-sales-force-data": _vm.salesForceInfo
                            },
                            on: { reflect: _vm.reflect }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.showUpgradeTab
                        ? _c(
                            "v-tab-item",
                            [
                              _c("opportunity-upgrade-pre", {
                                attrs: {
                                  "init-data": _vm.documentData,
                                  "is-link-complete": _vm.isLinkComplete(
                                    "opportunityToUpgradeStatusPre"
                                  ),
                                  "fetch-sales-force-info":
                                    _vm.fetchSalesForceInfo,
                                  "price-book-data": _vm.priceBook2DataUpgrade,
                                  "upgrade-to-standard-data-list":
                                    _vm.upgradeToStandardDataList,
                                  "init-sales-force-data": _vm.salesForceInfo
                                },
                                on: { reflect: _vm.reflect }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-tab-item",
                        [
                          _c("opportunity-additional-tablet-pre", {
                            attrs: {
                              "init-data": _vm.documentData,
                              "is-link-complete": _vm.isLinkComplete(
                                "opportunityAdditionalTabletStatusPre"
                              ),
                              "fetch-sales-force-info": _vm.fetchSalesForceInfo,
                              "price-book-data":
                                _vm.priceBook2DataAdditionalTablet,
                              "init-sales-force-data": _vm.salesForceInfo
                            },
                            on: { reflect: _vm.reflect }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab-item",
                        [
                          _c("opportunity-motion-ai-pre", {
                            attrs: {
                              "init-data": _vm.documentData,
                              "is-link-complete": _vm.isLinkComplete(
                                "opportunityMotionAiStatusPre"
                              ),
                              "fetch-sales-force-info": _vm.fetchSalesForceInfo,
                              "price-book-data": _vm.priceBook2DataMotionAi,
                              "init-sales-force-data": _vm.salesForceInfo
                            },
                            on: { reflect: _vm.reflect }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab-item",
                        [
                          _c("application-details-pre", {
                            attrs: {
                              "init-data": _vm.documentData,
                              "fetch-sales-force-info": _vm.fetchSalesForceInfo,
                              "init-sales-force-data": _vm.salesForceInfo,
                              "contract-status-continuity-check-record":
                                _vm.contractStatusContinuityCheckRecord,
                              "already-ekyc-latest-record":
                                _vm.alreadyEkycLatestRecord,
                              "document-id": _vm.documentData.documentId
                            },
                            on: { reflect: _vm.reflect }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("simple-dialog", {
        attrs: {
          "show-dialog": _vm.showAlertDialog,
          "default-msg": _vm.alertDialogMessage,
          "is-confirm": false,
          "is-html": true
        },
        on: {
          "ok-click": function($event) {
            return _vm.dialogClose()
          },
          "cancel-click": function($event) {
            return _vm.dialogClose()
          }
        }
      }),
      _vm._v(" "),
      _c("simple-dialog", {
        attrs: {
          "show-dialog": _vm.showReCorrectDialog,
          "max-width": "800",
          "default-msg": _vm.$t(
            "view.sales_force.reflect.msg.confirm_re_correct"
          )
        },
        on: {
          "ok-click": function($event) {
            return _vm.reCorrect()
          },
          "cancel-click": function($event) {
            return _vm.dialogClose()
          }
        }
      }),
      _vm._v(" "),
      _c("simple-dialog", {
        attrs: {
          "show-dialog": _vm.showAfterReCorrectDialog,
          "default-msg": _vm.$t(
            "view.sales_force.reflect.msg.confirm_after_re_correct"
          ),
          "max-width": "800"
        },
        on: {
          "ok-click": function($event) {
            return _vm.movePage()
          },
          "cancel-click": function($event) {
            return _vm.dialogClose()
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40cb9e82", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40cb9e82","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/sales_force/ReflectSalesForcePre.vue
// module id = bqJL
// module chunks = 1